import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/components/base-component/base-component.component';

@Component({
  selector: 'ui-drawer',
  templateUrl: './ui-drawer.component.html',
  styleUrls: ['./ui-drawer.component.scss'],
  standalone: false,
})
export class UiDrawerComponent extends BaseComponent {
  @Input() styleClass = 'w-6';
  @Input() showCloseIcon = true;
  @Output() drawerVisibleChange = new EventEmitter<boolean>();

  onVisibleChange(isVisible: boolean): void {
    this.layoutService.drawerVisible$.next(isVisible);
    this.drawerVisibleChange.emit(isVisible);
  }
}
